/**
 * @generated SignedSource<<01cc3dfd4b8ee6c5958f604e2a525316>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SuppressExpensesOutsideProjectPeriodWarningInput = {
  projectId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type suppressExpensesOutsideProjectPeriodWarningMutation$variables = {
  input: SuppressExpensesOutsideProjectPeriodWarningInput;
};
export type suppressExpensesOutsideProjectPeriodWarningMutation$data = {
  readonly suppressExpensesOutsideProjectPeriodWarning: {
    readonly clientMutationId: string | null;
  } | null;
};
export type suppressExpensesOutsideProjectPeriodWarningMutation = {
  variables: suppressExpensesOutsideProjectPeriodWarningMutation$variables;
  response: suppressExpensesOutsideProjectPeriodWarningMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SuppressExpensesOutsideProjectPeriodWarningPayload",
    "kind": "LinkedField",
    "name": "suppressExpensesOutsideProjectPeriodWarning",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "suppressExpensesOutsideProjectPeriodWarningMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "suppressExpensesOutsideProjectPeriodWarningMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "06dff5a9095d1539c960a8a2ba628451",
    "id": null,
    "metadata": {},
    "name": "suppressExpensesOutsideProjectPeriodWarningMutation",
    "operationKind": "mutation",
    "text": "mutation suppressExpensesOutsideProjectPeriodWarningMutation(\n  $input: SuppressExpensesOutsideProjectPeriodWarningInput!\n) {\n  suppressExpensesOutsideProjectPeriodWarning(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "5fa079b7934db9785266c805bb0f7eeb";

export default node;
